// The client side of /api/signet (BUILD-BRIEF-R2 §11) — owned by the `signet` agent.
// STUB: shapes final, route 501 until wave 1.
import { request } from './client.js';
import type { SignetHandoverPayload, SignetHandoverResult, SignetHealth } from '../../shared/types.js';

/** Build the payload without sending it — the confirm modal shows exactly what will be sent. */
export function previewHandover(opportunityId: number): Promise<SignetHandoverPayload> {
  return request(`/signet/handover/${opportunityId}/preview`);
}

export function handover(opportunityId: number): Promise<SignetHandoverResult> {
  return request(`/signet/handover/${opportunityId}`, { method: 'POST' });
}

/** `mode: 'stub'` is an honest answer, not a failure: the payload is written to disk and the
 *  deal shows "pending Signet" until the endpoint exists. */
export function signetHealth(): Promise<SignetHealth> {
  return request('/signet/health');
}
